import type { WrapTextToWidth } from "./types";

export const wrapTextToWidth: WrapTextToWidth = ({
  text,
  maxWidth,
  font,
  context,
}) => {
  context.font = font;
  const widths = new Map<string, number>();
  const widthOf = (fragment: string) => {
    const known = widths.get(fragment);
    if (known !== undefined) return known;
    const width = context.measureText(fragment).width;
    widths.set(fragment, width);
    return width;
  };
  const spaceWidth = widthOf(" ");

  const lines: string[] = [];
  let line = "";
  let lineWidth = 0;
  const flushLine = () => {
    lines.push(line);
    line = "";
    lineWidth = 0;
  };
  const append = (fragment: string, fragmentWidth: number) => {
    line += fragment;
    lineWidth += fragmentWidth;
  };

  const paragraphs = text
    .replace(/\r\n?/g, "\n")
    .replace(/\t/g, " ")
    .split("\n");
  for (const paragraph of paragraphs) {
    const words = paragraph.split(" ").filter((word) => word !== "");
    if (words.length === 0) {
      lines.push("");
      continue;
    }
    for (const word of words) {
      const wordWidth = widthOf(word);
      if (wordWidth > maxWidth) {
        // Nothing can hold the word whole, so it is broken wherever the line fills up.
        if (line !== "") flushLine();
        for (const character of word) {
          const characterWidth = widthOf(character);
          if (line !== "" && lineWidth + characterWidth > maxWidth) flushLine();
          append(character, characterWidth);
        }
        continue;
      }
      if (line === "") {
        append(word, wordWidth);
        continue;
      }
      if (lineWidth + spaceWidth + wordWidth > maxWidth) {
        flushLine();
        append(word, wordWidth);
        continue;
      }
      append(` ${word}`, spaceWidth + wordWidth);
    }
    if (line !== "") flushLine();
  }

  while (lines.length > 1 && lines[lines.length - 1] === "") lines.pop();
  return lines.length === 0 ? [""] : lines;
};
